module.exports = __webpack_public_path__ + "static/media/logo.ff84eb6a.svg";